<template>
    <b-card header="Profile"
        header-bg-variant="info"
        header-text-variant="white"
        >
        <form @submit.prevent="" @keydown="form.clearError($event.target.name)">
            <b-row>
                <b-col lg="6">
                    <b-form-group label="First Name *" label-for="firstname">
                        <b-form-input
                            name="firstname"
                            type="text"
                            v-model="form.firstname"
                            :disabled=" !create && isCarrierManager "
                        >
                        </b-form-input>
                        <input-help :form="form" field="firstname" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="Last Name *" label-for="lastname">
                        <b-form-input
                            name="lastname"
                            type="text"
                            v-model="form.lastname"
                            :disabled=" !create && isCarrierManager "
                            >
                        </b-form-input>
                        <input-help :form="form" field="lastname" text=""></input-help>
                    </b-form-group>

                  <b-form-group label="Date of Birth" label-for="dob">
                        <date-picker v-model="form.date_of_birth" placeholder="Date (MM/DD/YYYY)" :disabled=" !create && isCarrierManager "></date-picker>
                        <input-help :form="form" field="dob" text=""></input-help>
                  </b-form-group>

                    <b-form-group label="Gender" label-for="gender">
                        <b-form-radio-group v-model="form.gender" :disabled=" !create && isCarrierManager ">
                            <b-form-radio value="m">Male</b-form-radio>
                            <b-form-radio value="f">Female</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                    <b-form-group label="Options" label-for="sister_policy">
                        <b-form-checkbox id="sister_policy" v-model="form.sister_policy" value="1" :disabled=" !create && isCarrierManager ">
                            Has Sister Policy
                        </b-form-checkbox>
                        <b-form-checkbox id="claimant_transitioned" v-model="form.claimant_transitioned" value="1">
                           Claimant transferred from another vendor
                        </b-form-checkbox>
                    </b-form-group>
                </b-col>
                <b-col lg="6">
                    <b-row>
                        <b-col cols="8">
                            <b-form-group label="Email Address (Username)" label-for="email">
                                <b-form-input
                                    id="email"
                                    name="email"
                                    type="email"
                                    v-model=" form.email "
                                    :disabled=" form.no_email || ( !create && isCarrierManager ) "
                                    >
                                </b-form-input>
                                <input-help :form="form" field="email" text=""></input-help>
                            </b-form-group>
                        </b-col>
                        <b-col cols="4">
                            <div class="form-check">

                                <b-form-checkbox v-model=" form.no_email " :value=" true " @input=" toggleNoEmail() " :disabled=" !create && isCarrierManager ">No Email</b-form-checkbox>
                            </div>
                        </b-col>
                    </b-row>

                    

              
                    <div v-if="claimantIsCalpers || form.ltc_carrier_id === CalPERS_Carrier">                            
                        <b-form-group label="Coverage Id Number *" label-for="num">
                            <b-form-input
                                id="coverage_id_number"
                                name="coverage_id_number"
                                type="text"
                                v-model="form.coverage_id_number"
                            >
                            </b-form-input>
                            <input-help :form=" form " field="coverage_id_number" text=""></input-help>
                        </b-form-group>
                    </div>

                    <div v-else-if="claimantIsCNAg || form.ltc_carrier_id === CNA_Group_Carrier">
                        <b-form-group label="Certificate Number" label-for="num">
                            <b-form-input
                                id="cert_no"
                                name="cert_no"
                                type="text"
                                v-model="form.cert_no"
                            >
                            </b-form-input>
                            <input-help :form=" form " field="cert_no" text=""></input-help>
                        </b-form-group>
                    </div>

                    <div v-else>
                        <div v-if="getPolicyName">
                            <b-form-group :label="getPolicyName" label-for="num">
                                <b-form-input
                                    id="num"
                                    :readonly="!isAdmin && !isOfficeUser"
                                    name="num"
                                    type="text"
                                    v-model="num"
                                >
                                </b-form-input>
                                <input-help :form=" form " field="num" text=""></input-help>
                            </b-form-group>
                        </div>

                        <div v-else>
                            <b-form-group label="Policy Number" label-for="num">
                                <b-form-input
                                    id="policy_number"
                                    name="policy_number"
                                    type="text"
                                    v-model="form.policy_number"
                                >
                                </b-form-input>
                                <input-help :form=" form " field="policy_number" text=""></input-help>
                            </b-form-group>

                            <b-form-group label="Claim Number" label-for="num">
                                <b-form-input
                                    id="claim_number"
                                    name="claim_number"
                                    type="text"
                                    v-model="form.claim_number"
                                >
                                </b-form-input>
                                <input-help :form=" form " field="claim_number" text=""></input-help>
                            </b-form-group>
                        </div>
                    </div>

                    <b-form-group>
                        <b-form-checkbox v-model=" form.opt_out " :value=" true " @input=" toggleNoEmail() " :disabled=" !create && isCarrierManager ">Opt Out of Communications</b-form-checkbox>
                    </b-form-group>


                    <b-form-group label="Parent Carrier" label-for="parent_carrier">
                        <b-form-input :value=" parentCarrierName " disabled />
                    </b-form-group>


                    <b-form-group label="Block" label-for="ltc_carrier_id">
                        <carrier-dropdown :role=" role " ref="carrierDropdown" v-model="form.ltc_carrier_id" :disabled=" !!client.id || ( !create && isCarrierManager ) " :withEmpty="true"></carrier-dropdown>
                        <input-help :form="form" field="ltc_carrier_id" text=""></input-help>
                    </b-form-group>

                    <b-form-group label="Carrier Specific ID / Member ID" label-for="member_id">
                        <b-form-input
                                name="member_id"
                                type="text"
                                v-model="form.member_id"
                                :disabled=" !create && isCarrierManager "
                        >
                        </b-form-input>
                        <input-help :form="form" field="member_id" text=""></input-help>
                    </b-form-group>
                </b-col>
            </b-row>


            <hr />
            <h3>Power of Attorney</h3>
            <b-row>
                <b-col md="6">
                    <b-form-group label="First Name" label-for="poa_first_name">
                        <b-form-input
                            v-model="form.poa_first_name"
                            id="poa_first_name"
                            name="poa_first_name"
                            type="text"
                            :disabled=" !create && isCarrierManager "
                        ></b-form-input>
                        <input-help :form="form" field="poa_first_name" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="Last Name" label-for="poa_last_name">
                        <b-form-input
                            v-model="form.poa_last_name"
                            id="poa_last_name"
                            name="poa_last_name"
                            type="text"
                            :disabled=" !create && isCarrierManager "
                        ></b-form-input>
                        <input-help :form="form" field="poa_last_name" text=""></input-help>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Phone Number" label-for="poa_phone">
                        <b-form-input
                            v-model="form.poa_phone"
                            id="poa_phone"
                            name="poa_phone"
                            type="text"
                            :disabled=" !create && isCarrierManager "
                        ></b-form-input>
                        <input-help :form="form" field="poa_phone" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="Email Address" label-for="poa_email">
                        <b-form-input
                            v-model="form.poa_email"
                            id="poa_email"
                            name="poa_email"
                            type="text"
                            :disabled=" !create && isCarrierManager "
                        ></b-form-input>
                        <input-help :form="form" field="poa_email" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="Relationship to Client" label-for="poa_relationship">
                        <b-form-input
                            v-model="form.poa_relationship"
                            id="poa_relationship"
                            name="poa_relationship"
                            type="text"
                            :disabled=" !create && isCarrierManager "
                        ></b-form-input>
                        <input-help :form="form" field="poa_relationship" text=""></input-help>
                    </b-form-group>
                </b-col>
            </b-row>

          <div v-if="isHighLevelOrManager">
            <hr />
            <h3>Invoice Submission Settings</h3>
            <b-row>
              <b-col lg="6" style="position: relative">
                <div id="loader" v-show="targeted_date_loading">
                    <b-spinner label="Spinning"></b-spinner>
                </div>
                <div v-if="!client.carrier.invoice_auto_transmit && !client.carrier.client_payment_day_enabled">
                  <p>CE Automatically Submits Invoices for this Claimant: <strong>No</strong></p>
                  <p>Claimant must log into their account and click to submit invoices.</p>
                </div>
                <div v-if="client.carrier.invoice_auto_transmit && !client.carrier.client_payment_day_enabled">
                  <p>CE Automatically Submits Invoices for this Claimant: <strong>Yes (No claimant action required)</strong></p>
                  <p>CE will automatically transmit invoices on {{ client.carrier.invoice_submission_day | capitalize }} at {{ client.carrier.invoice_submission_day.invoice_submission_time }} Eastern Time.</p>
                  <p>Invoice Transmission Type: {{ client.carrier.invoice_transmission_type }}</p>
                </div>
                <div v-if="client.carrier.invoice_auto_transmit && client.carrier.client_payment_day_enabled">
                  <p>CE Automatically Submits Invoices Based on Carrier Payment Day: <strong>Yes (No claimant action required)</strong></p>
                  <div v-if="client.carrier.invoice_transmission_type == 'ftp_batch' ">
                    <p>Invoice Transmission Type: Batch / Zip</p>
                    <p>Invoice File Transfer Type: SFTP</p>
                    <p>Invoice Submission Frequency: {{ client.carrier.invoice_submission_day }}</p>
                    <p>Invoice Submission Time: {{ client.carrier.invoice_submission_time }}</p>
                  </div>
                  <div v-if="client.carrier.invoice_transmission_type == 'email_batch' ">
                    <p>Invoice Transmission Type: Batch / Zip</p>
                    <p>Invoice File Transfer Type: Email</p>
                    <p>Invoice Submission Frequency: {{ client.carrier.invoice_submission_day }}</p>
                    <p>Invoice Submission Time: {{ client.carrier.invoice_submission_time }}</p>
                  </div>

                  <b-form-group label="Carrier Payment Day" label-for="payment_day">
                    <b-select name="payment_day" id="payment_day" v-model="form.payment_day" @change="checkTargetedDate">
                      <option value="">-- None / Uses Carrier Default --</option>
                      <option v-for="num in Array.from({length: 31}, (_, i) => i + 1)" :key="num" :value="num" v-text="num" />
                      <input-help :form="form" field="payment_day" text="Select day of month and be sure to verify the next invoice submission date below."></input-help>
                    </b-select>

                  </b-form-group>
                  <b-form-group v-show="form.payment_day != ''" label="Submission Day Offset" label-for="invoice_delta">
                    <b-form-input
                        id="invoice_delta"
                        name="invoice_delta"
                        type="text"
                        readonly
                        disabled
                        v-model="client.carrier.invoice_delta"
                    >
                    </b-form-input>
                    <input-help :form="form" field="invoice_delta" text="This is read from carrier settings."></input-help>
                  </b-form-group>

                  <b-form-group label="Last Invoice Submission Date" label-for="last_submitted_at">
                    <b-form-input
                        id="last_submitted_at"
                        name="last_submitted_at"
                        type="text"
                        readonly
                        disabled
                        v-model="lastSubmittedAtDisplay"
                    >
                    </b-form-input>
                  </b-form-group>


                  <b-form-group label="Next Invoice Submission Date" label-for="targeted_date">
                    <b-form-input
                        id="targeted_date"
                        name="targeted_date"
                        type="text"
                        readonly
                        disabled
                        v-model="targetedDateDisplay"
                    >
                    </b-form-input>
                  </b-form-group>



                </div>

              </b-col>
              <b-col lg="6">
              </b-col>
            </b-row>
          </div>

          <hr />
          <b-row>
            <b-col>
              <h3>Enrollment</h3>
            </b-col>
          </b-row>
            <b-row>
                <b-col lg="6">
                    <b-form-group label="Enrollment Status" label-for="enrollment_status">
                        <span>{{ formatEnrollmentStatus(this.client.enrollment_status) }}</span>
                    </b-form-group>
                </b-col>
                <b-col lg="6" v-if=" !isCarrierManager ">
                    <b-form-group label="Assigned Specialist" label-for="specialist_id">
                        <b-select name="specialist_id" id="specialist_id" v-model="form.specialist_id">
                            <option value="">-- Select a Specialist --</option>
                            <option v-for="admin in admins" :key="admin.id" :value="admin.id">{{ admin.nameLastFirst }}</option>
                        </b-select>
                        <input-help :form="form" field="specialist_id" text=""></input-help>
                    </b-form-group>
                </b-col>
                <b-col lg="6">
                    <b-form-group label="Enrolled At" label-for="enrolled_at">
                        <span>{{ fixDate(this.client.enrolled_at) }}</span>
                    </b-form-group>
                </b-col>
                <b-col lg="6">
                    <b-form-group label="Enrollment Sent At" label-for="enrollment_sent_at">
                        <span>{{ fixDate(this.client.enrollment_sent_at) }}</span>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="6">
                    <b-form-group label="Enrollment / Setup Code" label-for="ssn" v-if="userNotEnrolled || !isSetUp">
                        <div class="d-flex align-items-start">
                            <span v-if="enrollmentCode" class="enrollment-code mr-3">{{ enrollmentCode }}</span>
                            <span v-else class="mr-3">This user does not have an enrollment code</span>
                            <b-button v-if=" !isCarrierManager && isUnenrolled( client.enrollment_status ) " variant="info" @click="enrollClient()">Admin Enroll</b-button>
                        </div>
                    </b-form-group>
                    <b-form-group label="Account Set Up At" label-for="account_setup_at" v-else-if="isSetUp">
                        <span>{{ fixDate(this.client.account_setup_at) }}</span>
                    </b-form-group>
                </b-col>
                <b-col lg="6">
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="12">
                    <b-button variant="success" size="lg" type="submit" v-if="create" @click="saveProfile()">Save and Continue</b-button>
                    <b-button variant="success" size="lg" type="submit" v-else-if=" isAdmin || isOfficeUser" @click="saveProfile()" :disabled="noSave">Save Profile</b-button>
                    <b-button variant="success" size="lg" type="submit" v-else-if="isCarrierManager" @click="updatePaymentDate()" :disabled="noSave">Save Profile</b-button>
                    <b-button variant="danger" size="lg" v-if="!isCarrierManager && !create && userNotEnrolled" @click="destroy">Delete Claimant</b-button>
                </b-col>
            </b-row>

        </form>
    </b-card>


</template>

<script>
    import DatePicker from './DatePicker';
    import FormatsDates from '../mixins/FormatsDates';
    import FormatsListData from "../mixins/FormatsListData";
    import EnrollmentStatuses from "../mixins/EnrollmentStatuses";
    import UsesRole from "../mixins/UsesRole";
    import PolicyFieldMixin from '../mixins/PolicyFieldMixin'
    import moment from "moment";
    import ManageDob from "./ManageDob.vue";

    export default {
        props: {
            'client': {},
            'lastStatusDate' : {},
            'confirmUrl': {},
            'create': Boolean,
            carriers: {
                type: Array,
                default: () => { return []; },
            },
        },

        mixins: [FormatsDates, FormatsListData, EnrollmentStatuses, UsesRole, PolicyFieldMixin],

        components: {
            DatePicker,
            ManageDob,
        },

        data() {
            return {
                targeted_date: null,
                targeted_date_loading: false,
                paymentUpdating : false,
                form            : new Form(),
                active          : this.client.active,
                admins          : [],
                selectedCarrier : {},
                CNA_Group_Carrier: Number,
                CalPERS_Carrier: Number,
            }
        },

        computed: {
          getDob() {
              if (this.client.id > 0){
               return  this.client.user.date_of_birth ? moment(this.client.user.date_of_birth ).format( 'MM/DD/YYYY' ): null
            }
            return null;
          },
            getDateOptions() {
              return { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true, timeZone: 'America/New_York', timeZoneName: 'long'};
            },
            targetedDateDisplay() {
              if (typeof this.client.targeted_date === 'undefined') {
                return '';
              }
              return this.getFormattedDateString(this.targeted_date)
            },
            lastSubmittedAtDisplay() {
              if (!_.has(this.client, 'last_submission') || !_.has(this.client.last_submission, 'submitted_at') || !this.client.last_submission.submitted_at) {
                  return 'No invoices have been submitted for this claimant.';
              }
              return this.getFormattedDateString(this.client.last_submission.submitted_at)
            },
            noSave() {
              if (this.targeted_date_loading || this.paymentUpdating) {
                return true;
              }
              return false;
            },
            invoiceDayValid(){

                if(
                    this.carriers.length == 0 || // if no carriers are present
                    !this.carriers.map( c => c.id ).includes( this.form.ltc_carrier_id ) || // if client doesnt have a carrier id
                    this.carriers.find( c => c.id == this.form.ltc_carrier_id ).invoice_auto_transmit == 0 // clients carrier doesnt have the setting
                ) return false;

                return true;
            },
            invoiceDayText(){

                if( this.form.ltc_carrier_id && this.carriers.find( c => c.id == this.form.ltc_carrier_id ).invoice_auto_transmit == 0 ) return `The claimant's block does not have auto-submit-invoices enabled.`;

                return "Override the invoice submission day for this particular claimant. The 29th & 30th automatically adjust to the last day of the month for months that don't have that many days";
            },
            userNotEnrolled() {
                return this.isNotEnrolled(this.client.enrollment_status);
            },
            isSetUp() {
                return !!this.client.account_setup_at;
            },
            enrollmentCode() {
                if (this.isEnrolled(this.client.enrollment_status) && this.isSetUp) {
                    return null;
                }

                let code = this.client.enrollment_code;
                if (code && this.selectedCarrier.parent_carrier.name !== "CalPERS") {
                    if (code.indexOf('-') < 0 && code.length == 8) {
                        return code.substring(0, 4) + '-' + code.substring(4, 8);
                    }
                    return code;
                } 
                
                if (this.selectedCarrier?.parent_carrier?.name === "CalPERS"){
                    const template = this.selectedCarrier.client_enrollment_code;
                    const prefix = template.split('#')[0];
                    return prefix + this.client.coverage_id_number;
                }
            },
            parentCarrierName() {
                if (this.selectedCarrier && this.selectedCarrier.parent_carrier) {
                    return this.selectedCarrier.parent_carrier.name;
                }
                return '';
            }
        },

        methods: {
          getFormattedDateString(item) {
            const date = new Date(item)
            return date.toLocaleDateString('en-US', this.getDateOptions);
          },
          async checkTargetedDate() {
            this.targeted_date_loading = true;
            const formData = {payment_day: this.form.payment_day};
            const request = new Form(formData);
            const url = `/client/${this.client.id}/payment-day`;
            try {
              const {data} = await request.post(url);
              this.targeted_date = data.data.targeted_date;
            } finally {
              this.targeted_date_loading = false;
            }
          },
          setupNum() {
            const value = this.getClientPolicyValueByClient(this.client);
            if (!value) {
              return;
            }
            this.num = value;
          },
          setPolicyNumberByWatcher(value) {
            if (!this.getCarrierObject) {
              return;
            }
            if (!this.policyField) {
              return;
            }
            this.$set(this.form, this.policyField, value);
          },
            setForm(){
                this.form = new Form({
                    firstname        : this.client.firstname,
                    lastname         : this.client.lastname,
                    date_of_birth    : this.getDob,
                    email            : this.formatEmail( this.client.email ),
                    gender           : this.client.gender,
                    sister_policy    : this.client.sister_policy,
                    claimant_transitioned : this.client.claimant_transitioned,
                    claim_number      : this.client.claim_number,
                    policy_number    : this.client.policy_number,
                    coverage_id_number    : this.client.coverage_id_number || "",
                    specialist_id    : this.client.specialist_id || "",
                    opt_out          : this.client.user ? this.client.user.opt_out : false,
                    ltc_carrier_id   : this.client.ltc_carrier_id ? this.client.ltc_carrier_id : '',
                    member_id        : this.client.member_id ? this.client.member_id : '',

                    payment_day      : this.client.payment_day ? this.client.payment_day : '',

                    no_email         : this.formatEmail( this.client.email ) == '',

                    poa_first_name   : this.client.poa_first_name,
                    poa_last_name    : this.client.poa_last_name,
                    poa_phone        : this.client.poa_phone,
                    poa_email        : this.client.poa_email,
                    poa_relationship : this.client.poa_relationship,
                    cert_no          : this.client.cert_no || "",
                });
            },
            async updatePaymentDate(){
                try {
                  this.paymentUpdating = true;
                  let form = new Form({ 
                    payment_day : this.form.payment_day,
                    claimant_transitioned : this.form.claimant_transitioned,
                  });
                  await form.patch( `/carriermanager/claimants/${this.client.id}` )
                } finally {
                  this.paymentUpdating = false;
                }
            },
            async saveProfile() {
                let method = this.client.id ? 'patch' : 'post';
                let url = this.claimantUrlPrefix;

                if (this.client.id) {
                  url = url + '/' + this.client.id;
                }

                const response = await this.form.submit(method, url);
                if (method === 'post') {
                    // let client = {
                    //     ...this.client,
                    //     ...response.data.data
                    // };
                    // this.$emit('update:client', client);
                    // this.$emit('continue');
                }
            },

            toggleNoEmail() {

                if( this.form.no_email ) this.form.email = '';
            },

            async enrollClient() {
                if (!confirm('Are you sure you wish to enroll this claimant?')) {
                    return;
                }
                let form = new Form({
                    status: 'admin_enrolled',
                });
                await form.put( `${this.claimantUrlPrefix}/${this.client.id}/status`);
            },

            destroy() {
                if (!confirm(`Are you sure you want to delete ${this.client.name}?`)) {
                    return;
                }

                if (!confirm(`Really delete ${this.client.name}?  This cannot be undone.`)) {
                    return;
                }

                let form = new Form();
                form.submit('delete', `${this.claimantUrlPrefix}/${this.client.id}`)
                    .then( response => {} )
            },

            fetchAdmins() {
                axios.get(`/${this.controller}/specialists`)
                    .then( ({ data }) => {
                        this.admins = data;
                    })
                    .catch(e => {
                        this.admins = [];
                    })
            },

            getCNAGroupID() {
                for (let carrier of this.carriers) {
                    // Strip spaces and lower case
                    let carrier_match = carrier.initials.toLowerCase().replace(" ", "")

                    if (carrier_match === "cnagroup" || carrier_match === "cnag") {
                        this.CNA_Group_Carrier = carrier.id
                        break
                    } 
                }
            },

            getCalpersGroupID() {
                for (let carrier of this.carriers) {
                    // Strip spaces and lower case
                    let carrier_match = carrier.initials.toLowerCase().replace(" ", "")

                    if (carrier_match === "calpers") {
                        this.CalPERS_Carrier = carrier.id
                        break
                    } 
                }
            },

            fixDate(timestamp, defaultText = 'N/A') {
                if (! timestamp) {
                    return defaultText;
                }
                return this.formatDateTimeFromUTC(timestamp);
            },
        },

        created(){
            this.setForm();
            this.setupNum();
        },

        async mounted() {
            // Pull the ID for CNA Group and store it in a prop for later comparison
            this.getCNAGroupID();
            this.getCalpersGroupID();


            await this.fetchAdmins();

            if( this.form.ltc_carrier_id ){
                this.selectedCarrier = this.carriers.find(x => x.id === this.form.ltc_carrier_id);
            }
            if (typeof this.client.targeted_date !== 'undefined') {
              this.targeted_date = this.client.targeted_date;
            }
        },

        watch: {
            'form.ltc_carrier_id'( newValue ){
                if( !newValue ) {
                  return;
                }

                this.selectedCarrier = this.carriers.find( x => x.id === newValue );
            },
        },
    }
</script>

<style scoped>
    .enrollment-code {
        font-size: 24px;
        font-weight: bold;
        color: blue;
    }
     #loader {
       position: absolute;
       top: 0;
       bottom: 0;
       left: 0;
       right: 0;
       align-items: center;
       align-content: center;
       display: flex;
       justify-content: center;
       z-index: 2;
       background: rgba(0, 0, 0, 0.3);
     }
</style>
